import React, { useEffect, useRef, useState } from "react";
import Help1 from "../image/help1.png";
import Help2 from "../image/help2.png";
import Help3 from "../image/help3.png";
const Help = () => {
  // Define styles as a string
  const styles = `
    .help-container {
      text-align: center;
      padding: 2rem;
      background-color: #f0f8ff;
    }

    .help-container h1 {
      color: #4c2b85;
      font-size: 2rem;
    }

    .cards-container {
      display: flex;
      justify-content: space-between;
      padding: 2rem;
    }

    .card {
      background-color: white;
      border-radius: 10px;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
      padding: 2rem;
      text-align: center;
      width: 25%;
      transition: transform 0.3s ease;
      display: flex; /* Added to make the card a flex container */
      flex-direction: column; /* Arrange children in a column */
      align-items: center; /* Center items horizontally */
      justify-content: center; /* Center items vertically */
    }

    .card:hover {
      transform: translateY(-10px);
    }

    .icon-container {
      width: 85px; /* Set the width of the circle */
      height: 85px; /* Set the height of the circle */
      border-radius: 50%; /* Makes the container circular */
      background: linear-gradient(to right, #f0f8ff, #e6f7ff, #b3e0ff);
      display: flex; /* Use flexbox to center the image */
      align-items: center; /* Center vertically */
      justify-content: center; /* Center horizontally */
    }

    .card img {
      width: 85px; 
      height: 85px; 
    }

    .card h2 {
      color: #4c2b85;
      font-size: 1.5rem;
    }

    .card p {
      color: #777;
      font-size: 1rem;
      margin-top: 0.5rem;
      text-align: justify;
    }

    .ratio-container {
      font-size: 1.2rem;
      margin-bottom: 1rem;
      color: #23395d;
    }

    .ratio-text {
      display: inline-block;
      font-size: 1.5rem;
      font-weight: bold;
      color: #23395d;
      margin-right: 0.5rem;
    }

    .ratio-box {
      display: inline-block;
      font-size: 1.5rem;
      font-weight: bold;
      color: #23395d;
      border: 2px solid #23395d;
      padding: 0.5rem;
      border-radius: 5px;
    }

    .source {
      font-size: 0.9rem;
      color: #777;
      margin-top: 1rem;
    }

    @media (max-width: 768px) {
      .cards-container {
        flex-direction: column;
        align-items: center;
      }

      .card {
        width: 80%;
        margin-bottom: 1.5rem;
      }
    }
  `;

  const [count, setCount] = useState(0);
  const countRef = useRef(null);

  // Function to handle scrolling to the counter
  const handleScroll = () => {
    const rect = countRef.current.getBoundingClientRect();
    if (rect.top <= window.innerHeight && rect.bottom >= 0) {
      // Start counting up to 10000 when the component is in view
      let start = -13;
      const end = 10000;
      const duration = 20; // Duration of the counter animation in milliseconds
      const incrementTime = duration / end;

      const increment = () => {
        if (start < end) {
          start = start + 31;
          setCount(start);
          setTimeout(increment, incrementTime);
        }
      };

      increment();
      window.removeEventListener("scroll", handleScroll);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <style>{styles}</style>
      <div className="help-container" id="WhyPhysiomize">
        <h1>How can we help you with Physio-Mize!</h1>
        <div className="ratio-container">
          Ratio of Physiotherapist to Patient in India is{"  "}
          <div className="ratio-text"> 0.59 : </div>
          <div className="ratio-box" ref={countRef}>
            {count}
          </div>
        </div>
        <div className="source">
          Source:{" "}
          <a
            href="https://www.physio-pedia.com/India"
            target="_blank"
            rel="noopener noreferrer"
          >
            Physio-pedia
          </a>
        </div>
        <div className="cards-container">
          <div className="card">
            <div className="icon-container">
              <img src={Help1} alt="Affordable Access" />
            </div>
            <h2>Affordable Access</h2>
            <p>
              We offer a low-cost, portable solution for joint angle
              measurement, making physiotherapy accessible in remote areas.
            </p>
          </div>
          <div className="card">
            <div className="icon-container">
              <img src={Help2} alt="Personalized Treatment" />
            </div>
            <h2>Personalized Treatment</h2>
            <p>
              High-precision sensors and an app enable physiotherapists to
              monitor recovery and create customized treatment plans based on
              real-time data.
            </p>
          </div>
          <div className="card">
            <div className="icon-container">
              <img src={Help3} alt="Enhanced Communication" />
            </div>
            <h2>Enhanced Communication</h2>
            <p>
              We bridge the gap between patients and physiotherapists, allowing
              for effective guidance throughout the recovery journey, regardless
              of distance.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Help;
